export interface PeakCandidateFrame {
  ts: Date;
  y: number;
  prominence: number | null;
}

export interface PeakApexMarker {
  ts: Date;
  y: number;
  prominence: number;
}

const groupPeakEvents = (
  frames: readonly PeakCandidateFrame[]
): PeakCandidateFrame[][] =>
  frames.reduce<PeakCandidateFrame[][]>((events, frame, index) => {
    if (frame.prominence === null) return events;
    const currentEvent = events[events.length - 1];
    const continuesEvent =
      currentEvent !== undefined &&
      frames[index - 1]?.prominence === frame.prominence;
    if (continuesEvent) {
      currentEvent.push(frame);
    } else {
      events.push([frame]);
    }
    return events;
  }, []);

// Collapse each peak event to one apex marker (its highest frame). Events write
// a constant prominence across their window, so a prominence change ends one.
export const collapsePeakRunsToApexes = (
  frames: readonly PeakCandidateFrame[]
): PeakApexMarker[] =>
  groupPeakEvents(frames).map((event) => {
    const apex = event.reduce((highest, frame) =>
      frame.y > highest.y ? frame : highest
    );
    return { ts: apex.ts, y: apex.y, prominence: apex.prominence ?? 0 };
  });
